import { createFileRoute } from '@tanstack/react-router';
import type { ReactElement } from 'react';
import { z } from 'zod';

import { LinkViews } from '~/features/links/os/link-views';

/** The step past the rule (when it fires, or what carries over), and `by=hand` for the link changed by hand. */
const search = z.object({ step: z.enum(['condition', 'fields']).optional(), by: z.enum(['hand']).optional() });

/**
 * One stored link, opened for a change: OS first (board access-link-edit-os),
 * or by hand on the same rule (boards access-link-editor, access-link-condition, access-link-fields).
 */
function LinkRoute(): ReactElement {
  const { recordId, linkId } = Route.useParams();
  const { step, by } = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <LinkViews
      key={`${recordId}-${linkId}`}
      recordId={recordId}
      linkId={linkId}
      by={by ?? null}
      step={step ?? 'rule'}
      onStep={(next) => void navigate({ search: (prev) => ({ ...(prev.by === undefined ? {} : { by: prev.by }), ...(next === 'rule' ? {} : { step: next }) }) })}
      onBy={(next) => void navigate({ search: next === null ? {} : { by: next } })}
    />
  );
}

export const Route = createFileRoute('/_app/records/$recordId/links/$linkId')({
  validateSearch: search,
  component: LinkRoute,
});
